import { Popover } from 'antd';
import React, { FC, useContext, useMemo, useState } from 'react';
import Calender, { DateRangeType } from '../Calender';
import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import dayjs from 'dayjs';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { default as CalenderIcon } from 'assets/svg/Calender';
import { colorConstants } from 'config/colorConstants';
import { FilterContextData } from 'contexts/FilterContext';

type Props = {
    setPriceEffectiveDate: Function;
    setTempPriceEffectiveDate: Function;
    isEffectiveDateBetweenSimulationDate: Function;
    priceEffectiveDate: [any, any];
    tempPriceEffectiveDate: [any, any];
    simulationDateRange: [any, any];
};
const currentDate = new Date();

const SingleDatePicker: FC<Props> = ({
    priceEffectiveDate,
    setPriceEffectiveDate,
    setTempPriceEffectiveDate,
    tempPriceEffectiveDate,
    isEffectiveDateBetweenSimulationDate,
    simulationDateRange,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const { viewMode } = useContext(pricingSimulatorDataContext);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const { calenderStartDay } = useContext(FilterContextData);
    const dateLabel = useMemo(() => {
        let startLabel = 'Select Date';
        if (priceEffectiveDate[1]) startLabel = dayjs(new Date(priceEffectiveDate[1])).format(commonConfig?.dateFormat);
        return { startLabel };
    }, [priceEffectiveDate]);
    const handleOpenChange = (newOpen: boolean, isClickOutside: boolean = true) => {
        setIsOpen(newOpen);
        if (!newOpen && !isClickOutside) {
            //only save the date when clicked on set date button
            setPriceEffectiveDate(tempPriceEffectiveDate);
            // trackEventMixpanel(PSR_PRICE_EFFECTIVE_DATE_CHANGED, {
            //     priceEffectiveDate: tempPriceEffectiveDate[1],
            // });
        } else if (!newOpen) {
            //if clicked outside dont save the change,
            setTempPriceEffectiveDate(priceEffectiveDate);
        }
    };
    const startYear = tempPriceEffectiveDate?.[1]
        ? dayjs(tempPriceEffectiveDate?.[1]).year()
        : currentDate.getFullYear();

    const disabledDates: [string | number | null, string | number | null] = [
        dayjs(simulationDateRange?.[0] ?? currentDate).format('MM-DD-YYYY'),
        simulationDateRange?.[1] ? dayjs(simulationDateRange?.[1]).format('MM-DD-YYYY') : null,
    ];

    const handleDateChange = (range: DateRangeType) => {
        //only add date if its between simulation date
        if (isEffectiveDateBetweenSimulationDate(undefined, range)) {
            setTempPriceEffectiveDate([...range]);
        }
    };
    return (
        <div>
            <Popover
                trigger="click"
                open={!viewMode && isOpen}
                onOpenChange={(open) => handleOpenChange(open)}
                placement={'bottom'}
                content={
                    <Calender
                        minYear={currentDate.getFullYear()}
                        startYear={startYear}
                        maxYear={currentDate.getFullYear() + 2}
                        disabledDates={disabledDates}
                        startDay={calenderStartDay}
                        range={tempPriceEffectiveDate}
                        onChange={handleDateChange}
                        onFooterClick={() => handleOpenChange(false, false)}
                        singleDateSelect={true}
                    />
                }
            >
                <div className="flex justify-center items-center w-40">
                    <div
                        className={` ${
                            !viewMode ? 'cursor-pointer' : ''
                        } w-full flex justify-start gap-1 py-1 items-center px-3 bg-white border border-borderGreyAl1 hover:border-[#40a9ff]
                        ${isOpen ? 'border-[#40a9ff] shadow-md' : ''}
                        rounded-md`}
                    >
                        <div className="flex w-full">
                            <span
                                className={`${
                                    priceEffectiveDate[1] && !isOpen
                                        ? 'text-subHeaderColor'
                                        : dateLabel.startLabel !== 'Select Date'
                                        ? 'text-greyFont'
                                        : 'text-[#bfbfbf]'
                                }  font-xs`}
                            >
                                {dateLabel.startLabel}
                            </span>
                        </div>
                        <CalenderIcon stroke={colorConstants.greyAlt} />
                    </div>
                </div>
            </Popover>
        </div>
    );
};

export default SingleDatePicker;
